import { createCRUDService, fetchDropdowns } from './createCRUDService';
import {VACCINATION_RECORD, DROPDOWNS } from './api/endpoints';

// Create base CRUD service
const baseCRUD = createCRUDService(VACCINATION_RECORD.BASE);

// Export service with additional custom methods
export const RecordService = {
  ...baseCRUD,

  // Override getAll to handle status uppercase conversion
  getAll: async ({ page = 1, limit = 100, status, search } = {}) => {
    const params = { page, limit };
    if (status) params.status = status.toUpperCase();
    if (search) params.search = search;
    return baseCRUD.getAll(params);
  },

  // Get dropdown data
  getAgeGroups: () => fetchDropdowns(DROPDOWNS.BASE),
};

export default RecordService;
